export default __webpack_public_path__ + "static/Frame4-5d9af2fec881e9d2bcf1a3c90c440eeb.svg";